import { UserViewsQueryResult } from '../interfaces/UserViewsQueryResult';
import { gql, useQuery } from '@apollo/client';

export const USER_VIEWS_QUERY = gql`
  query GetUserViews {
    userViews {
      viewId
      viewName
      appName
      base64Embedding
      userEmail
      createdAt
      lastModified
    }
  }
`;

// Refetch after a view mutation. Deduplication is off so the refetch is always a new request:
// otherwise it can join a GetUserViews still in flight from an earlier mutation and receive a
// list fetched before this mutation landed (e.g. a just-deleted view reappearing).
export const REFETCH_USER_VIEWS = {
  query: USER_VIEWS_QUERY,
  context: { queryDeduplication: false },
};

export const useUserViews = (appName?: string) => {
  const { data, loading, error, refetch } = useQuery<UserViewsQueryResult>(
    USER_VIEWS_QUERY,
    { errorPolicy: 'all' }
  );

  const allViews = data?.userViews ?? [];
  const views = appName
    ? allViews.filter((view) => view.appName === appName)
    : allViews;

  return { views, loading, error, refetch };
};
